import script from "./HorarioAlumno.vue?vue&type=script&setup=true&lang=js"
export * from "./HorarioAlumno.vue?vue&type=script&setup=true&lang=js"

import "./HorarioAlumno.vue?vue&type=style&index=0&id=18288308&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18288308"]])

export default __exports__